import { render, staticRenderFns } from "./niche-order-form.vue?vue&type=template&id=2fe6b991"
import script from "./niche-order-form.vue?vue&type=script&lang=js"
export * from "./niche-order-form.vue?vue&type=script&lang=js"
import style0 from "./niche-order-form.vue?vue&type=style&index=0&id=2fe6b991&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports